export interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

export type ExperimentMap = Record<string, ExperimentData>;
export type ExperimentData = Record<string, unknown>;

export enum SubCategoryExperimentValues {
    control = 'control',
    subCategories = 'subcategories',
}

export const SubCategoryExperiment: Experiment<
    typeof SubCategoryExperimentValues
> = {
    name: 'search_subcategory_filters',
    paramName: 'category_type',
    values: SubCategoryExperimentValues,
};

export const HomepageSeasonalCarouselValues = {
    control: 'hide',
    test: 'show',
};

export const HomepageSeasonalCarouselExperiment: Experiment<
    typeof HomepageSeasonalCarouselValues
> = {
    name: 'mardi_gras_new_orleans',
    paramName: 'mardi_gras_carousel',
    values: HomepageSeasonalCarouselValues,
};

export const DatingInNightlifeValues = {
    control: 'hide',
    test: 'show',
};

export const DatingInNightlifeExperiment: Experiment<
    typeof DatingInNightlifeValues
> = {
    name: 'dating_carousel_on_homepage',
    paramName: 'dating_tab',
    values: DatingInNightlifeValues,
};

export const SearchDesktopStaticMapImageValues = {
    control: 'hide',
    variant: 'show',
};
export const SearchDesktopStaticMapImageExperiment: Experiment<
    typeof SearchDesktopStaticMapImageValues
> = {
    name: 'search-desktop-static-map-image',
    paramName: 'static-map',
    values: SearchDesktopStaticMapImageValues,
};
